import React, { useState, useEffect } from "react";
import moment from "moment";
import TextField from "@material-ui/core/TextField";
import SimpleComment from "./SimpleComment";
import Button from '@material-ui/core/Button';
import PremiumBadge from "./PremiumBadge.js";

export default props => {
    const [text, setText] = useState("");
    const [comments, setComments] = useState([]);
    // const [error, setError] = useState('');

    useEffect(() => {
        // console.log('SimpleInputComment', props);

        setText(props.prop);
        setComments(props.comments || []);
    }, [props.prop]);

    useEffect(() => {
        if (props.prop === text) return;
        const t = window.setTimeout(() => {
            if ((props.showError && text.length >= 6) || !props.showError || props.type !== 'cpr') props.changeValue(text);

        }, 300);
        return () => window.clearTimeout(t);
    }, [props, text]);

    const addComment = (fieldName) => {
        if (comments.length > 0 && comments[comments.length - 1].id === null) {
            return
        }
        const newComments = [...comments];
        newComments.push({
            id: null,
            journalId: props.journalId !== undefined ? props.journalId : null,
            customFieldName: fieldName,
            value: '',
            clientId: props.clickedClient.id,
            customFieldId: props.customFieldId !== undefined ? props.customFieldId : null,
            refId: 'refid-' + new Date().getTime()
        });
        setComments(newComments);
    }
    const savedComment = (comment) => {

        const newComments = [...comments];
        const ix = newComments.findIndex(cm => cm.id === comment.id);
        if (ix > -1) {
            newComments[ix] = comment;
        } else if (newComments[newComments.length - 1].id === null) {
            newComments[newComments.length - 1] = comment;
        }
        setComments(newComments);
    }

    const geFieldLabel = (fieldText, updatedAt) => {
        let updatedInfo = '';
        if (updatedAt) {
            updatedInfo = ` - ${props.therapist.nameFirst} ${props.therapist.nameLast} ` + moment(updatedAt).format("DD/MM/YYYY HH:mm:ss")
        }

        return `${fieldText}${updatedInfo}`;
    }

    return (
        <>
            { props.multiline === true ? (
                <div className="field-with-comments" style={{ width: "100%" }}>
                    <TextField
                        label={geFieldLabel(props.text, props.updatedAt)}
                        required={props.required}
                        id={props.id}
                        multiline
                        InputLabelProps={{ shrink: true }}
                        type={props.type || "text"}
                        value={text}
                        onChange={event => setText(event.target.value)}
                        style={{ margin: "10px auto 10px auto", width: "100%" }}
                        disabled={props.disabled || props.canEditData === false}
                        InputProps={{
                            endAdornment: (props.enableComment === true) ?
                                <Button onClick={() => { addComment(props.name) }} className="btn-new-comment" color="primary"
                                    disabled={!props.canEditData === false}>Skriv kommentar</Button>
                                : <></>
                        }}
                    />
                    { !props.canEditData && props.enableComment === true ? (
                        <div className="comments">
                            {comments.map((comment) => {
                                return (
                                    <SimpleComment
                                        label={geFieldLabel(`Kommentar til ${props.text}`, comment.updatedAt)}
                                        id={'idsim-' + (comment.id || comment.refId)}
                                        key={'keysim-' + (comment.id || comment.refId)}
                                        comment={comment}
                                        onSavedComment={savedComment}
                                    />
                                );
                            })}
                        </div>
                    ) : (
                        <></>
                    )}
                </div>
            ) : (
                <div style={{ width: "100%" }}>
                    <TextField
                        id={props.id}
                        label={props.text}
                        InputLabelProps={{ shrink: true }}
                        type={props.type || "text"}
                        value={text}
                        onChange={event => setText(event.target.value)}
                        style={{ margin: "10px auto 10px auto", width: "100%" }}
                        disabled={props.disabled || props.canEditData === false}
                        required={props.required}
                        InputProps={{
                            endAdornment: props.disabled ? <PremiumBadge /> : ""
                        }}

                        inputProps={{
                            maxLength: props.maxLength,
                        }}
                    />
                </div>
            )}
        </>
    );
};